import { CustomDataObjectArea } from './custom-data-object-area.model';

export interface CustomDataObject {
    ID: number;
    ModuleIDs: number[];
    Name: string;
    ObjectTypeID: number;
    ObjectAreas: CustomDataObjectArea[];
    IsValidForCustomPages: boolean;
   }

   export enum enmCustomDataObjects {
    Student = 4,
    Household = 7,
    HouseholdContact = 8,
    NonresidentParent = 9,
    EmergencyContact = 10,
    Enrollment = 11,
    FacultyStaff = 13,
    StudentByYear = 14,
    StaffHealthCondition = 15,
    StaffHealthVisit = 16,
    StaffAttendance = 17,
    StudentHealthPractitioner = 18,
    StudentHealthCondition = 19,
    StudentHealthPregnancy = 20,
    StudentHealthVisit = 21,
    StudentHealthRestriction = 22,
    StudentHealthInsurance = 23,
    StateReportingByYear = 24,
    StudentHealthDose = 25,
    StudentHealthHearingScreenings = 26,
    DistrictCourses = 28,
    StudentHealthSpinalScreenings = 30,
    StudentHealthPhysicalScreenings = 31,
    StudentHealthDentalScreenings = 32,
    StudentHealthVisionScreenings = 33,
    Sections = 34,
    SchoolCourses = 37,
    StudentHealthMedication = 38,
    Address = 39,
    UserLogin = 40,
    StateReporting = 41,
    BehaviorEvents = 42,
    BehaviorIncidents = 43,
    BehaviorActions = 44,
    BehaviorReferrals = 45
}